import { BrandSettings } from "./BrandSettings";
import React from "react";
import { TransactionSettings } from "./TransactionSettings";

export type ActionButtonPropInterface = (
  reset: (event: any) => void,
  submit: (event: any) => void,
  options?: any
) => React.ReactNode;
export const SettingContentsRender = (
  index: number,
  submitComponent: (
    reset: (event: any) => void,
    submit: (event: any) => void,
    options?: any
  ) => React.ReactNode
) => {
  console.log(submitComponent);
  switch (index) {
    case 1:
      return <TransactionSettings ActionButtons={submitComponent} />;
    case 0:
    default:
      return <BrandSettings ActionButtons={submitComponent} />;
  }
};
export default SettingContentsRender;
